// react
import { useState } from 'react';

// router
import { useParams } from 'react-router-dom';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Entity } from '../../../@types';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormUploadDocs } from '../../forms/FormUploadDocs/FormUploadDocs';

// props
export interface DialogUploadDocsEntityProps {
	entity: Entity;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogUploadDocsEntity = ({
	entity,
	isOpen,
	onClose,
	onSuccess,
}: DialogUploadDocsEntityProps) => {
	// hooks
	const { idEntity } = useParams();
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('uploadDocuments'),
					form: 'form-upload-docs-entity',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			alignItems="center"
			hasClose={true}
			IconCircleProps={{
				type: 'document',
			}}
			isOpen={isOpen}
			onClose={onClose}
			subtitle={{ children: !idEntity ? entity.name : undefined }}
			title={{
				children: t('uploadDocuments'),
			}}>
			<FormUploadDocs
				entity={entity}
				onClose={onClose}
				onSuccess={onSuccess}
				setIsLoading={setIsLoading}
			/>
		</DialogActions>
	);
};
